export default __webpack_public_path__ + "static/media/vintage-varsity.193726ce.png";